import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link, Navigate } from "react-router-dom";

import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "./orderFail.css";

import { useOrder } from "../../contexts/OrderContext";
import Loader from "../commonComponents/Loader/Loader";

export default function OrderFail() {
  const { isInFetch, status } = useOrder();

  const isFetching = isInFetch();

  if (!isFetching && Number(status) !== 3) return <Navigate to="/" replace />;

  return (
    <div className="upper-container order-fail-container">
      {isFetching ? (
        <Loader loading={isFetching} />
      ) : (
        <div className="order-fail-box">
          <h2 className="fail-message">تراکنش ناموفق ● ﹏ ●</h2>
          <p className="fail-desc">
            در صورت کسر مبلغ از حسابتان ، مبلغ تا 72 ساعت آینده به حساب شما
            برگردانده می شود.
          </p>

          <Link className="fail-return-link" to="/">
            بازگشت به فروشگاه
            <FontAwesomeIcon icon={faChevronLeft} fontSize="13px" />
          </Link>
        </div>
      )}
    </div>
  );
}
